import PortfolioPage from "./PortfolioPage";
import Footer from "./sections/Footer";

function App() {
  return (
    <div className="App">
      <PortfolioPage />
      <Footer />
    </div>
  );
}

export default App;
